import React, { useEffect, useState } from 'react';

const About = () => {
  const [settings, setSettings] = useState(null);

  // Fetch settings data from API
  useEffect(() => {
    fetch('https://app.bimbelstemakupang.com/api/settings')
      .then(response => response.json())
      .then(data => setSettings(data))
      .catch(error => console.error('Error fetching settings:', error));
  }, []);

  if (!settings) {
    return <div>Loading...</div>; // Loading state while the data is being fetched
  }

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="about-image">
              {/* Dynamically load the image from the API */}
              <img
                src={`https://app.bimbelstemakupang.com/storage/${settings.about_image}`}
                alt="Bimbel Stema Kupang"
                className="img-fluid main-image"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content">
              <h2>Apa Itu Sekolah Kedinasan?</h2>
              <p className="lead">
                Sekolah kedinasan adalah perguruan tinggi yang dinaungi oleh kementerian atau lembaga pemerintah tertentu dan mencetak tenaga profesional yang siap bekerja langsung di sektor pemerintahan.
              </p>
              <h4>🎯 Tujuan Sekolah Kedinasan</h4>
              <p>Mencetak lulusan yang siap kerja di instansi pemerintah, dengan keahlian sesuai bidang studi yang mereka tempuh.</p>
              <h4>💡 Manfaat Sekolah Kedinasan</h4>
              <p>Lulusan sekolah kedinasan memiliki jaminan penempatan kerja sebagai ASN (Aparatur Sipil Negara), menjadikan masa depan lebih terarah dan terjamin sejak awal.</p>
              <div className="row features-row">
                <div className="col-md-6">
                  <div className="feature-item">
                    <div className="icon"><i className="bi bi-award"></i></div>
                    <h4>Ikatan Dinas</h4>
                    <p>Langsung menjadi ASN setelah lulus, sesuai instansi yang menaungi sekolah tersebut.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="feature-item">
                    <div className="icon"><i className="bi bi-building-check"></i></div>
                    <h4>Jaminan Karir</h4>
                    <p>Jalur karir lebih jelas dan stabil sejak awal dibanding lulusan umum.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="feature-item">
                    <div className="icon"><i className="bi bi-star"></i></div>
                    <h4>Persaingan Sehat</h4>
                    <p>Seleksi masuk dilakukan secara nasional dan transparan berbasis CAT.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="feature-item">
                    <div className="icon"><i className="bi bi-person-check"></i></div>
                    <h4>Diprioritaskan Jadi ASN</h4>
                    <p>Mayoritas alumni diangkat langsung menjadi pegawai di instansi terkait.</p>
                  </div>
                </div>
              </div>
              <div className="cta-button mt-4">
                <a href="#program" className="btn btn-primary">Kenali Program Bimbel Kami</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
